/* eslint-disable @typescript-eslint/no-explicit-any */
"use client";

import dayjs from "dayjs";
import dynamic from "next/dynamic";
import Image from "next/image";
import { twMerge } from "tailwind-merge";

import { useLang } from "@/hooks/use-lang";

import { useBlogDetailsMaskType } from "../../hooks/use-blog-dtails-mask-type";
import { ArticleInfo } from "../../services/article-info";

/* eslint-disable @typescript-eslint/no-explicit-any */

/* eslint-disable @typescript-eslint/no-explicit-any */

const Parser = dynamic(
  () => import("../article-parser/Parser").then((module) => module.Parser),
  {
    ssr: false,
  }
);

export const ArticleContent = ({
  title,
  primaryCategory,
  secondaryCategory,
  coverPicture,
  author,
  keywords,
  content,
  publishedAt,
}: ArticleInfo) => {
  const { t } = useLang();
  const { type } = useBlogDetailsMaskType();

  return (
    <div
      className={twMerge(
        "relative overflow-clip",
        type !== "none" ? "h-[1000px]" : ""
      )}
    >
      <div className="space-y-3">
        {coverPicture && (
          <div className="relative h-[230px]">
            <Image
              fill
              placeholder="blur"
              alt="Cover image"
              src={coverPicture}
              className="object-cover object-center"
              blurDataURL="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAADUlEQVR42mPk8cr7DwAC8wHF8e4zAAAAAABJRU5ErkJggg=="
              aria-label="Cover image"
            />
          </div>
        )}
        <p
          className="pt-9 text-sm font-bold  text-green-700"
          aria-label="article category"
        >
          {t.blog.category[primaryCategory]}/
          {t.blog.category[secondaryCategory]}
        </p>
        <h1 className="pb-5 text-2xl font-bold" aria-label="article title">
          {title}
        </h1>
        <div className="flex items-center justify-between">
          <p aria-label="article author">
            {t.blog.author}
            {author}
          </p>
          <p aria-label="article published date">
            {t.blog.updatedAt}
            {dayjs(publishedAt).format("YYYY-MM-DD")}
          </p>
        </div>
      </div>
      <div id="article-parser" aria-label="article content">
        <Parser data={content as any} />
      </div>
      <div aria-label="article keywords" className="flex flex-wrap gap-2">
        {keywords &&
          keywords.map<React.ReactNode>((keyword, index) => (
            <span
              key={index}
              className="inline-block rounded-md border border-zinc-300 bg-zinc-100 px-1.5 py-0.5 text-xs"
            >
              # {keyword}
            </span>
          ))}
      </div>
    </div>
  );
};
